import React from "react";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Typography,
} from "@material-tailwind/react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const menuItems = [
  {
    title: {
      bn: "প্রশাসনিক বিভাগ",
      en: "Department of Administration",
    },
    link: "/department-of-administration",
  },
  {
    title: {
      bn: "বায়োকেমিস্ট্রি বিভাগ",
      en: "Department of Biochemistry",
    },
    link: "/department-of-biochemistry",
  },
  {
    title: {
      bn: "মাইক্রোবায়োলজি বিভাগ",
      en: "Department of Microbiology",
    },
    link: "/department-of-microbiology",
  },
  {
    title: {
      bn: "হেমাটোলজি বিভাগ",
      en: "Department of Hematology",
    },
    link: "/department-of-hematology",
  },
  {
    title: {
      bn: "প্যাথলজি বিভাগ",
      en: "Department of Pathology",
    },
    link: "/department-of-pathology",
  },
  {
    title: {
      bn: "ক্লিনিক্যাল প্যাথলজি বিভাগ",
      en: "Department of Clinical Pathology",
    },
    link: "/department-of-clinical-pathology",
  },
  {
    title: {
      bn: "ভাইরোলজি বিভাগ",
      en: "Department of Virology",
    },
    link: "/department-of-virology",
  },
  {
    title: {
      bn: "রেডিওলজি এন্ড ইমেজিং বিভাগ",
      en: "Department of Radiology and Imaging",
    },
    link: "/department-of-radiology-and-imaging",
  },
  {
    title: {
      bn: "ট্রান্সফিউশন বিভাগ",
      en: "Department of Transfusion",
    },
    link: "/department-of-transfusion",
  },
];

export default function DeptDrop() {
  const lang = localStorage.getItem("language");
  const { pathname } = useLocation();
  const isCurrentPath = (path) => {
    return pathname === path;
  };

  const [openMenu, setOpenMenu] = React.useState(false);

  const triggers = {
    onMouseEnter: () => setOpenMenu(true),
    onMouseLeave: () => setOpenMenu(false),
  };

  return (
    <Menu open={openMenu} handler={setOpenMenu}>
      <MenuHandler>
        <p
          {...triggers}
          variant="paragraph"
          className={`hover:bg-red-900 flex gap-2 hover:text-white border-0 lg:border-gray-500 lg:border-[1px] lg:border-t-0 px-6 py-[6px] lg:border-l-0 ${
            isCurrentPath("/department-of-administration") ||
            isCurrentPath("/department-of-biochemistry") ||
            isCurrentPath("/department-of-microbiology") ||
            isCurrentPath("/department-of-hematology") ||
            isCurrentPath("/department-of-pathology") ||
            isCurrentPath("/department-of-clinical-pathology") ||
            isCurrentPath("/department-of-virology") ||
            isCurrentPath("/department-of-radiology-and-imaging") ||
            isCurrentPath("/department-of-transfusion")
              ? "bg-red-900 text-white "
              : ""
          }`}
        >
          {lang === "en" ? "Departments" : "বিভাগসমূহ"}

          <span className="block lg:hidden">
            <ChevronDownIcon
              strokeWidth={1.5}
              className={`h-3.5 w-3.5 transition-transform ${
                openMenu ? "rotate-180" : ""
              }`}
            />
          </span>
        </p>
      </MenuHandler>
      <MenuList
        {...triggers}
        className="w-[4-rem] md:w-[13rem] p-0 overflow-visible"
      >
        <ul className="col-span-4 flex w-full flex-col">
          {menuItems.map(({ title, link }) => (
            <Link to={link} className="" key={title.en}>
              <MenuItem className="p-2">
                <Typography variant="small" color="black" className="text-sm">
                  {lang === "en" ? title.en : title.bn}
                </Typography>
              </MenuItem>
            </Link>
          ))}
        </ul>
      </MenuList>
    </Menu>
  );
}
